import { CALL_API } from '../middleware/api'

export const ENROLMENTS_SETTINGS_REQUEST = 'ENROLMENTS_SETTINGS_REQUEST'
export const ENROLMENTS_SETTINGS_SUCCESS = 'ENROLMENTS_SETTINGS_SUCCESS'
export const ENROLMENTS_SETTINGS_FAILURE = 'ENROLMENTS_SETTINGS_FAILURE'

export const ENROLMENTS_REQUEST = 'ENROLMENTS_REQUEST'
export const ENROLMENTS_SUCCESS = 'ENROLMENTS_SUCCESS'
export const ENROLMENTS_FAILURE = 'ENROLMENTS_FAILURE'

export const fetchEnrolments = (from_date, to_date, refresh = false) => (dispatch, getState) => {
	
	const enrolments = getState().enrolments;
	const now = Math.floor(Date.now() / 1000);
	if (!refresh && enrolments && enrolments.expires >= now && from_date >= enrolments.from && to_date <= enrolments.to) {
		return null
	} else if(enrolments.submitting && enrolments.fetching_from === from_date && enrolments.fetching_to === to_date){
		return null
	}

	const user = getState().user;
	
	return dispatch({
		[CALL_API]: {
			types: [ ENROLMENTS_REQUEST, ENROLMENTS_SUCCESS, ENROLMENTS_FAILURE ],
			endpoint: '/enrolments/',
			method: 'POST',
			params: {
				member_no: user.member_no,
				from_date: from_date,
				to_date: to_date,
				include_enrolled: true,
				include_waitlisted: true,
				include_subscriptions: true,
				include_special_interests: true
			},
			bad_response: 'Error fetching enrolments from U-MAS database',
			add_data: {
				from: from_date,
				to: to_date
			}
		}
	})
}

export const loadEnrolmentsSettings = (refreshEnrolments = false) => (dispatch, getState) => {
	const user = getState().user;
	const currentSettings = getState().settings.enrolments;
	const now = Math.floor(Date.now() / 1000) // JS dates are in milliseconds!
	
	if (currentSettings && currentSettings.expires >= now) {
		if(refreshEnrolments && user.member_no > 0 && currentSettings.data.member_courses_start_date){
			dispatch(fetchEnrolments(currentSettings.data.member_courses_start_date, currentSettings.data.member_courses_end_date));
		}
		return null
	}
	
	return dispatch({
		[CALL_API]: {
			types: [ENROLMENTS_SETTINGS_REQUEST, ENROLMENTS_SETTINGS_SUCCESS, ENROLMENTS_SETTINGS_FAILURE],
			endpoint: '/settings/',
			method: 'GET',
			params: {
				settings: 'enrolments'
			},
			bad_response: 'Error fetching enrolments settings from U-MAS database'
		}
	}).then(result => {
		if(user.member_no > 0 && result.type === 'ENROLMENTS_SETTINGS_SUCCESS' && result.response.member_courses_start_date){
			dispatch(fetchEnrolments(result.response.member_courses_start_date, result.response.member_courses_end_date));
		}
	})
}